import React from 'react';

import { Grid, CircularProgress } from '@mui/material';

import GoBack from 'js/containers/GoBack.js';
import {
  getLastUserInfo,
  trackEventMatomoVisit,
} from 'js/library/utils/helpers';
import { recommendOrgs } from 'js/library/utils/API/recommendOrgs.js';
import OrganizationItem from 'js/containers/Organizations/OrganizationItem';
import { useState } from 'react';
import { useEffect } from 'react';

export default function AddOrganizations() {
  const [orgs, setOrgs] = useState(null);

  useEffect(() => {
    document.title = 'Adicionar organizacao';
    trackEventMatomoVisit('Adicionar organizacao');
  });

  useEffect(() => {
    if(orgs === null) {
        const userInfo = getLastUserInfo();

        recommendOrgs(userInfo.uId).then((result) => {
            if (result.success) {
              setOrgs(result.orgs);
            } else {
              setOrgs(false);
            }
          });
    }
  }, [orgs]);

  return (
    <div>
      {orgs === null ? (
        <div style={{ textAlign: 'center' }} className="loading-content">
          <CircularProgress />
        </div>
      ) : (
        <div>
          <GoBack />

          <Grid container spacing={0}>
            {orgs.map((row, i) => {
              return <OrganizationItem key={i} data={row} />;
            })}
          </Grid>
        </div>
      )}
    </div>
  );
}
